import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from '@insolution/store-data-access';
import { ELanguage } from '@insolution/shared-data-access';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from '@insolution/auth-data-access';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private localStorageService = inject(LocalStorageService);
  private translateService = inject(TranslateService);
  private authService = inject(AuthService);

  private storeLanguageOnChangeIsCalled$ = new Subject<void>();

  constructor() {
    this.setLanguage();
  }

  public storeLanguageOnChange() {
    this.storeLanguageOnChangeIsCalled$.next();

    this.translateService.onLangChange
      .pipe(takeUntil(this.storeLanguageOnChangeIsCalled$))
      .subscribe((event) => this.localStorageService.storeItemByUser<'language'>('language', event.lang as ELanguage));
  }

  private async setLanguage() {
    await this.authService.waitForLoginStatus();

    const storedLanguage = this.localStorageService.getItemByUser<'language'>('language');

    if (storedLanguage) {
      this.translateService.use(storedLanguage);
      return;
    }

    this.translateService.use('nl-NL');
  }
}
